import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { Field } from 'formik'
import { DatePicker } from './DatePicker'

interface DatePickerFieldProps extends Partial<DatePickerProps<true>> {
  name: string
  'data-testid'?: string
  ciboSourced?: boolean
  inlineClearButton?: boolean
  stringValue?: boolean
  error?: boolean
}

export const DatePickerField = (props: DatePickerFieldProps) => {
  const { name, ciboSourced, error, 'data-testid': dataTestId, ...datePickerProps } = props

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Field
        component={DatePicker}
        ciboSourced={ciboSourced}
        name={name}
        {...datePickerProps}
        slotProps={{
          ...datePickerProps.slotProps,
          textField: {
            size: 'small',
            error,
            'data-testid': dataTestId,
            // @ts-ignore slotProps does in fact exist on this object
            ...datePickerProps.slotProps?.textField,
          },
          field: {
            ...datePickerProps.slotProps?.field,
          },
        }}
      />
    </LocalizationProvider>
  )
}
